<template>
<div class="pageCoinRecharge" id="">  
  <XR-head titleText="WUA提现" :rightShow="false" ref="head"></XR-head>
  <div class="login-form">
  <mu-row gutter>
    <mu-col width="100" tablet="100" desktop="33">
      <mu-text-field label="提现账户" helpText="请输入WUA钱包地址" labelFloat fullWidth v-model="withdrawInfo.ZhiLianAddress" />
    </mu-col>
  </mu-row>
  <mu-row gutter>
    <mu-col width="100" tablet="100" desktop="33">
      <mu-text-field label="提现金额" helpText="" labelFloat fullWidth v-model="withdrawInfo.Coin" />
    </mu-col>
  </mu-row>
  <mu-row gutter>
    <mu-col width="100" tablet="50" desktop="33" class="login-div">
      <mu-raised-button label="确 定" class="demo-raised-button" primary fullWidth @click="open()" />
      
      <mu-popup position="bottom" popupClass="pageWuaWithdrawPayPopup" :open="PayPopup" @close="close()">
        <mu-content-block>
          <p class="title">输入支付密码</p>
          <mu-divider></mu-divider>
          <p class="withdrawResult">提现WUA{{coinValue.toFixed(4)}}</p>
          <mu-text-field label="支付密码" type="password" fullWidth labelFloat v-model="withdrawInfo.PayPassword" />
          <mu-raised-button label="提现" class="submit" primary fullWidth @click="submit()" />
        </mu-content-block>
      </mu-popup>

    </mu-col>
  </mu-row>
  <mu-row gutter>
    <mu-col width="100" tablet="50" desktop="33" class="div3">
      <XR-toast @onClose="goBack" ref="XRtoast"></XR-toast>
    </mu-col>
  </mu-row>
</div>
</div>
</template>
<script>
import {GUID} from '../../util/guid'
import md5 from 'js-md5'
import {ErrorCode} from '../../util/errorcode'
export default {
  data () {
    return {
      isShow : 'none',
      PayPopup : false,
      withdrawInfo:{
        RequestID: '',
        ZhiLianAddress : '',
        PayPassword:'',
        Coin : ''
      }
    }
  },
  mounted(){
    this.withdrawInfo.RequestID = new GUID().newGUID().replace('-','').replace('-','').replace('-','').replace('-','')
  },
  computed : {
    coinValue(){
      return this.withdrawInfo.Coin>0? parseFloat(this.withdrawInfo.Coin):0
    }
  },
  methods: {
    open () {
      this.PayPopup = true
    },
    close (position) {
      this.PayPopup = false
    },
    submit:function(){
      this.close()
      this.$refs.XRtoast.load('提现中...')
      var ths = this;   
      if(!ths.withdrawInfo.PayPassword){
        ths.$refs.XRtoast.failed('请输入支付密码', true)
        return
      }   
      ths.withdrawInfo.PayPassword = md5(ths.withdrawInfo.PayPassword)

      ths.$post(
        "/Shop/UserServer/WuaWithdraw",
        JSON.stringify(this.withdrawInfo)
      ).then(function(res) {
        if(!res.IsSuccess){       
          ths.withdrawInfo.PayPassword =''
          ths.$refs.XRtoast.failed(res.Msg, true)   
          if(res.TypeId == ErrorCode.SessionMissing){
            ths.$router.push("/Login")
          }
        }else{        
          ths.$refs.XRtoast.success(res.Msg, true)
        }
      });
    },
    goBack:function(){
      this.$router.goBack()
    }
  }
}

</script>
<style>
#app .pageCoinRecharge{
  background: white;
  bottom: unset;
}
.pageCoinRecharge .login-form {
  padding: 10px 20px 20px 10px;
}
.pageCoinRecharge .login-div {
  padding: 40px 0px 0 20px;
}
.pageCoinRecharge .demo-raised-button {
  height: 50px;
}
.pageCoinRecharge .div2 {
  padding: 20px 0 0 0;
}
.pageCoinRecharge .demo-flat-button.right {
  float: right;
}
.pageCoinRecharge .div3 {
  text-align: center;
  position: absolute;
  bottom: 40px;
  left: 0;
}
.pageCoinRecharge .pageCoinRecharge .notice{
  font-size: 12px;
}
.pageCoinRecharge .sms-button{
  margin-top: 28px;
  margin-bottom: 12px;
}

.pageWuaWithdrawPayPopup{
  width: 100%;
}
.pageWuaWithdrawPayPopup .title{
  font-size: 16px;
  text-align: center;
}
.pageWuaWithdrawPayPopup .withdrawResult{
  font-size: 14px;
  text-align: center;
  padding-top: 20px;
}
.pageWuaWithdrawPayPopup .submit{
  height: 50px;
}
</style>



// WEBPACK FOOTER //
// src/pages/usercenter/wuaWithdraw.vue